import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';



const CreatePostPage = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [color, setColor] = useState('bg-[#ffe84f]');
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [loading, setLoading] = useState(false);



  const navigate = useNavigate();
  const win = window.localStorage; 

    useEffect(()=>{
        getTags();
        checkUserLoggedIn();

    },[]);

    const checkUserLoggedIn = () => {
        if (localStorage.getItem('username') != null) {
            
        } else {
            navigate("/login");

        }
    };

    const getTags = async() =>{
        const response = await axios.get("https://api.ngomongdong.com/tags");
        setTags(response.data);
    }

    const handleTagChange = (e) => {
        const tag = e.target.value;
        if (e.target.checked) {
          setSelectedTags((prevRoles) => [...prevRoles, tag]);
        } else {
          setSelectedTags((prevRoles) => prevRoles.filter((prevRole) => prevRole !== tag));
        }
    };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Handle post submission logic here
//     console.log('Title:', title);
//     console.log('Content:', content);
//   };

  const savePost = async(e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", title); // nama "username" sesuai di backend
    formData.append("content", content); 
    formData.append("color", color); 
    formData.append("tags", selectedTags);
    // for user validation
    formData.append("username", win.getItem('username'));
    formData.append("pass", win.getItem('password'));

    setLoading(true);
    try {
        await axios.post("https://api.ngomongdong.com/curhatanpost", formData, {
            headers:{
                "Content-Type": "multipart/form-data"
            }
        });
        setIsModalOpen(true); // Show the modal on success
        // After a short delay, navigate to this page for refresh
        setTimeout(() => {
            // refresh page
            navigate("/explore");
        }, 3000); // 500ms delay, adjust as needed

        
    } catch (error) {
        // console.log(error.response.status);
        if (error.response.status == 400){
            // console.log(error.response + "error bangsat");
        }

        
    }
    finally {
        setLoading(false); // Stop loading after fetching or error
    }

  

  
      
      
    


  }

  const toggleColor = (e) => {
    setColor(e.target.value);
  };

  return (
    <div className="container mx-auto px-4">
  <h1 className="inline-block text-2xl font-hand mb-4 mt-8 text-gray-400 border-b border-gray-900">
    Buat Curhatan:
  </h1>
  
  {/* Main grid layout */}
  <div className="grid md:grid-cols-3 gap-5">
    {/* Form container */}
    <div className="bg-[#070707] p-5 md:col-span-2 rounded-lg shadow-lg">
      <form onSubmit={savePost}>
        <div className="mb-4">
          <label htmlFor="title" className="block text-gray-500 font-bold mb-2">
            Judul
          </label>
          <input
            type="text"
            id="title"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Ketikan judul curhatanmu..."
            value={title}
            required
            maxLength={150}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label htmlFor="content" className="block text-gray-500 font-bold mb-2">
            Isi
          </label>
          <textarea
            id="content"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            rows="6"
            placeholder="Ketikan isi curhatanmu..."
            value={content}
            maxLength={1500}
            onChange={(e) => setContent(e.target.value)}
          ></textarea>
        </div>

        {/* Tag selection */}
        <div className="flex flex-wrap mb-4 gap-3">
  {tags.map((tag) => (
    <div
      key={tag.tag_id}
      className="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem] mr-5 rounded-lg bg-[#0e0e0e] flex items-center"
    >
      <input
        className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
        type="checkbox"
        value={tag.tag_id}
        onChange={handleTagChange}
        id={`checkbox-${tag.tag_id}`}
      />
      <label htmlFor={`checkbox-${tag.tag_id}`} className="inline-block pl-[0.15rem] hover:cursor-pointer text-white">
        {tag.tag_name}
      </label>
    </div>
  ))}
</div>


        <button
          type="submit"
          disabled={loading}
          className={`w-full md:w-[150px] rounded-lg font-normal py-3 border border-white ${
            loading ? "cursor-not-allowed text-sm bg-[#0c0c0c] text-[#00df9a]" : "bg-black text-[#00df9a] hover:bg-[#0c0c0c]"
          }`}
        >
          {loading ? "Mengirim curhatan... ": "+ Kirim Curhatan"}
        </button>
      </form>
    </div>

    {/* Color selection and preview */}
    <div className="flex flex-col items-center break-words w-full">
      <div className={`rounded-lg shadow-md pb-8 break-words ${color} w-full h-80`}>
        <p className="text-3xl ml-2 mt-1 mr-2 font-hand text-black overflow-hidden break-all whitespace-normal">
            {title}
        </p>
      </div>


      <div className="mt-3 flex flex-wrap justify-center mb-5">
        <button
          onClick={(e) => toggleColor(e, "value")}
          type="button"
          className="text-gray-300 hover:bg-gray-700 hover:text-white px-5 py-3 m-2 rounded-md text-sm font-medium bg-[#ffe84f]"
          value="bg-[#ffe84f]"
        />
        {/* hover:bg-[#ffed75] */}
        <button
          onClick={(e) => toggleColor(e, "value")}
          type="button"
          className="text-gray-300 hover:bg-gray-700 hover:text-white px-5 py-3 m-2 rounded-md text-sm font-medium bg-[#98ff4f]"
          value="bg-[#98ff4f]"
        />
        {/* hover:bg-[#b6ff82] */}
        <button
          onClick={(e) => toggleColor(e, "value")}
          type="button"
          className="text-gray-300 hover:bg-gray-700 hover:text-white px-5 py-3 m-2 rounded-md text-sm font-medium bg-[#4fffff]"
          value="bg-[#4fffff]"
        />
        <button
          onClick={(e) => toggleColor(e, "value")}
          type="button"
          className="text-gray-300 hover:bg-gray-700 hover:text-white px-5 py-3 m-2 rounded-md text-sm font-medium bg-[#fb7aff]"
          value="bg-[#fb7aff]"
        />
        <button
          onClick={(e) => toggleColor(e, "value")}
          type="button"
          className="text-gray-300 hover:bg-gray-700 hover:text-white px-5 py-3 m-2 rounded-md text-sm font-medium bg-[#ff5656]"
          value="bg-[#ff5656]"
        />
      </div>
    </div>
  </div>
  {/* Modal for success */}
  {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center">
          <div className="bg-zinc-900 rounded-md shadow-md p-6">
            <h3 className="text-xl font-semibold mb-4 text-white">Curhatan Berhasil diposting !</h3>
            <p className='text-white'>Kembali ke beranda untuk melihat curhatanmu.</p>
            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-4 px-4 py-2 bg-[#00df9a] text-white rounded-md"
            >
              Oke
            </button>
          </div>
        </div>
      )}
</div>

  );
};

export default CreatePostPage;
